import {
  mapRecommendedNewbuildingToRecommendation,
  IRecommendationNewbuildingWithContact,
} from '../../mappers/requestCallback';
import { INewbuildingRecommendation } from '../../types/microfrontends/newbuildingCallbackWidget';
import { IRecommendationNewbuilding } from '../../types/recommendations';
import { IApplicationState } from '../../types/redux';
import { getBuilder } from '../newbuilding';
import { selectRecommendations } from '../newbuildingRecommendations';

export const isValidRecommendedNewbuilding = (
  newbuilding: IRecommendationNewbuilding,
): newbuilding is IRecommendationNewbuildingWithContact => Boolean(newbuilding.contact && newbuilding.contact.phone);

export const getCallbackRecommendations = (state: IApplicationState): INewbuildingRecommendation[] => {
  const builder = getBuilder(state);
  const recommendations = selectRecommendations(state);

  if (recommendations.length === 0 || !builder || builder.isPremium) {
    return [];
  }

  const recommendationsByBuilder = recommendations.reduce<Map<number, INewbuildingRecommendation>>((acc, item) => {
    if (isValidRecommendedNewbuilding(item)) {
      const builderRealtyId = item.contact.realtyUserId;

      if (!acc.has(builderRealtyId)) {
        const recommendation: INewbuildingRecommendation = mapRecommendedNewbuildingToRecommendation(item);

        acc.set(builderRealtyId, recommendation);
      }
    }

    return acc;
  }, new Map());

  recommendationsByBuilder.delete(builder.realtyUserId);

  return Array.from(recommendationsByBuilder.values()).slice(0, 3);
};
